exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.document-history-container{font-family:Open Sans,sans-serif;color:#2c2c2c;font-weight:600;line-height:normal;margin-left:48px;height:calc(100% - 95px);width:calc(33% - 2px)}.document-history-container h2{font-size:24px;font-weight:600;height:33px;margin-bottom:22px;margin-top:6px}.document-history-container .history-scroll-container{border-bottom:2px solid #9b9b9b;border-top:2px solid #9b9b9b;height:fit-content;max-height:calc(100% - 66px);overflow-x:hidden;overflow-y:auto}.document-history-container .chronological-list{width:calc(100% - 2px)}.document-history-container .doc-history-card{border-bottom:1px solid #e3e3e3;font-size:10px;margin:11px 0 16px;padding:0 0 16px 27px}.document-history-container .doc-history-card p{margin:0}.document-history-container .doc-history-card__title{font-size:14px;height:19px;overflow:hidden;padding-bottom:2px;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.document-history-container .doc-history-card__current-version,.document-history-container .doc-history-card__uploaded-name{color:#9b9b9b;font-weight:400}.document-history-container .doc-history-card__uploaded-by{font-style:italic}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentHistory/ReferenceDocumentHistory.scss
// module id = 1832
// module chunks = 0